export default [
    {
        id: 1,
        title: "Microsoft Teams",
        coverImg: "microsoftteams.webp",
        route: "microsoftteams",

    },
    {
        id: 2,
        title: "Microsoft Office",
        coverImg: "microsoftoffice.webp",
        route: "microsoftoffice",
    },
    {
        id: 3,
        title: "Microsoft Excel",
        coverImg: "microsoftexcel.webp",
        route: "microsoftexcel",
    },
    {
        id: 4,
        title: "Microsoft Power Point",
        coverImg: "microsoftpowerpoint.webp",
        route: "microsoftpowerpoint",
    },
    {
        id: 5,
        title: "Microsoft Outlook",
        coverImg: "microsoftoutlook.webp",
        route: "microsoftoutlook",
    },
    
]